import LoginForm from '../components/Form/LoginForm';
import { connect } from 'react-redux';
import PageLayout from '../components/pageLayout';
import "../styles/Form.css"


function FormPage(props) {

    return (
        <PageLayout children={<LoginForm />} />
    );
}
const mapStateToProps = (state) => ({ isLogged: state.user.isAuthenticated })

export default connect(mapStateToProps)(FormPage)
